// Campo de CEP da PDP (e da página /cart, B4). A tabela é baixada uma vez por página, só quando a
// pessoa calcula. Máscara, CEP lembrado e erro com WhatsApp vêm do ds-cep-ui.js — a gaveta usa os mesmos.
const core = await window.ArpineDS.importar("produto");
const ui = await window.ArpineDS.importar("cepUi");

const caixa = document.querySelector("[data-ds-cep]");
if (caixa) {
  const input = caixa.querySelector("[data-ds-cep-input]");
  const botao = caixa.querySelector("[data-ds-cep-botao]");
  const saida = caixa.querySelector("[data-ds-cep-saida]");
  let tabela = null;
  let versao = 0; // cliques/Enter em sequência: descarta resposta de uma chamada mais antiga

  ui.mascararCep(input);

  // Nós construídos com textContent: o CEP digitado nunca vira HTML.
  function mostrar(linhas, classe) {
    saida.hidden = false;
    saida.replaceChildren();
    for (const linha of linhas) {
      if (!linha) continue;
      const p = document.createElement("p");
      p.className = classe;
      p.textContent = linha;
      saida.append(p);
    }
  }

  // Duas mensagens distintas: CEP não reconhecido (formato inválido ou fora da tabela) x falha de
  // rede ao carregar a tabela de frete — são causas diferentes, avisos diferentes.
  function mostrarErro(mensagem) {
    saida.hidden = false;
    saida.replaceChildren(ui.paragrafoErro(mensagem, { href: caixa.dataset.waHref, rotulo: caixa.dataset.waLabel }));
  }
  const erroNaoReconhecido = () => mostrarErro(caixa.dataset.erro);
  const erroRede = () => mostrarErro(caixa.dataset.erroRede);

  async function calcular() {
    if (botao.disabled) return; // já tem um cálculo em curso (clique repetido, duplo toque, Enter)
    const digitado = input.value; // captura agora: o campo pode mudar enquanto o fetch está em voo
    const cep = core.normalizarCep(digitado);
    if (!cep) return erroNaoReconhecido();
    versao += 1;
    const minhaVersao = versao;
    botao.disabled = true;
    try {
      if (!tabela) {
        try {
          const r = await fetch(caixa.dataset.urlTabela);
          if (!r.ok) throw new Error(String(r.status));
          tabela = await r.json();
        } catch {
          if (minhaVersao === versao) erroRede();
          return;
        }
      }
      if (minhaVersao !== versao) return; // uma chamada mais nova já assumiu a tela
      const t = core.textoFrete(core.freteDoCep(tabela, cep));
      if (!t) return erroNaoReconhecido();
      ui.guardarCep(digitado); // o CEP calculado, não o que estiver no campo agora
      // Fora da PDP (página /cart) a retirada já está numa linha fixa: não repetir (mostrar pula null).
      const retirada = caixa.dataset.mostrarRetirada === "0" ? null : t.retirada;
      mostrar([t.envio, retirada], "ds-cep__linha-resultado");
    } finally {
      if (minhaVersao === versao) botao.disabled = false; // nunca deixa o botão morto, nem no erro
    }
  }

  botao.addEventListener("click", calcular);
  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      calcular();
    }
  });

  const anterior = ui.cepLembrado();
  if (anterior) {
    input.value = anterior;
    calcular();
  }
}
